import { atom } from "jotai";

export const receiveLrListAtom = atom([])
export const receiveLITLrListAtom = atom([])
export const LITReceiveAtom = atom(0)
export const ChallanListAtom = atom([])
export const selectChallanAtom = atom([])
export const showListAllAtom = atom(false)
export const receiveFilteredTableRowsAtom = atom([])
export const receiveFilteredTableSourceAtom = atom('')
